import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const TippyIcon = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="6"
      viewBox="0 0 16 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props.title}</title>
      <path
        d="M15.0078 -0.5C15.4952 -0.0122439 15.0229 0.490129 15.0049 0.5C14.9992 0.500053 14.9231 0.499973 14.7764 0.5C13.1909 0.500305 11.5933 1.41218 10.3467 2.39355C9.73304 2.87665 9.22446 3.36099 8.86914 3.72461C8.69187 3.90602 8.55326 4.05671 8.45996 4.16113C8.41333 4.21333 8.37773 4.25423 8.35449 4.28125C8.34291 4.29472 8.33456 4.30506 8.3291 4.31152C8.3264 4.31472 8.3244 4.31697 8.32324 4.31836L8.32227 4.31934L7.94922 4.76855L7.5625 4.33105L7.56152 4.3291C7.56022 4.32764 7.55765 4.32557 7.55469 4.32227C7.54879 4.31568 7.53965 4.3055 7.52734 4.29199C7.50247 4.26468 7.46452 4.2234 7.41504 4.1709C7.31605 4.06586 7.1694 3.91458 6.9834 3.73242C6.61066 3.3674 6.08072 2.88124 5.45215 2.39648C4.17101 1.40851 2.57521 0.500515 1.09766 0.5H0.995117C0.978923 0.487615 0.506451 -0.00437714 0.984375 -0.499023C0.989411 -0.499154 0.995327 -0.499982 0.99707 -0.5H15.0078Z"
        fill="white"
        stroke="#D7D8DA"
      />
    </svg>
  )
}
